export const AUTH_COOKIE = '@AUTH_COOKIE'
export const AUTH_TOKEN = '@auth_token'
export const NATIVE_BASE_URL = '@native_base_url'
export const VIDEO_AUTO_PLAY = '@video_auto_play'
export const ONBOARDING_DONE = '@onboarding_done'
export const CONTENTS_LIST_OPEN = '@contents_list_open'
export const PREMIO_RA_2026_PROMPT_SEEN = '@premio_ra_2026_prompt_seen'
export const SCHOOL_THEME = '@school_theme'
export const PUSH_PROMPT_SEEN = '@push_prompt_seen'
export const PUSH_DEVICE_TOKEN = '@push_device_token'
export const PUSH_PENDING_UNREGISTER = '@push_pending_unregister'
export const PUSH_OPENED_EVENT_KEYS = '@push_opened_event_keys'
